import { ChangeLogEntry } from 'components/change-log-request';
import React from 'react';

export const ChangeLogRequestPage: React.FC = () => {
    return <ChangeLogEntry />;
};
